import React from "react"
import styled from "styled-components"
import colors from "../utility/colors"
import { Technologies } from "./technologies"
import { Products } from "../components/products"
import InviewMonitor from "react-inview-monitor"
import { AnimatedWrap } from "../modules/animatedwrap"

const ShowcasesBase = styled.div`
  width: 100vw;
  background: linear-gradient(
    -25deg,
    ${props => colors.primary} 0%,
    ${props => colors.primary} 50%,
    ${props => colors.deep} 50%,
    ${props => colors.deep} 80%,
    ${props => colors.primary} 80%
  );
`

export const Showcases = () => (
  <AnimatedWrap>
    <InviewMonitor classNameInView="is-inview">
      <ShowcasesBase className="wrap">
        <Products />
        <Technologies />
      </ShowcasesBase>
    </InviewMonitor>
  </AnimatedWrap>
)
